const envBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

const backendUrl = envBackendUrl ? envBackendUrl.replace(/\/+$/, "") : "";

export default backendUrl;
